const encrypt = ({
  modulus, exponent, holderName, cardNumber, month, year, cvv, postalCode,
}) => {
  const { AMS } = window;
  if (AMS) {
    const accountInfo = new AMS.AccountInfo();
    accountInfo.setModulus(modulus);
    accountInfo.setExponent(exponent);

    if (holderName) {
      accountInfo.setCCCardholder(`${holderName}`.toUpperCase());
    }

    if (cardNumber) {
      accountInfo.setCCNumber(`${cardNumber}`);
    }

    if (month) {
      accountInfo.setCCExpMonth(`${month}`);
    }

    if (year) {
      accountInfo.setCCExpYear(`${year}`);
    }

    if (cvv) {
      accountInfo.setCCCsc(`${cvv}`);
    }

    if (postalCode) {
      accountInfo.setCCZip(`${postalCode}`);
    }

    return AMS.getCipher(accountInfo);
  }
  return 'No AMS object founded';
};

export default encrypt;
